import React from "react";
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom';

// Vistas de la aplicacion
import Login from "./views/Login.js";
import FirstRun from "./views/FirstRun.js";
import ResetPassword from "./views/ResetPassword.js";
import SensorsPanel from "./views/SensorsPanel.js";
import DataLoaderPanel from "./views/DataLoaderPanel.js";
import ControlPanel from "./views/ControlPanel.js";
import AdminPanel from "./views/AdminPanel.js";
import UserProfile from "./views/UserProfile.js";

// ATENCION! Para evitar errores 404 cuando se refresca una página en ReactJS es necesario redirigir todo el tráfico a la página de index, para lo cual en Tomcat se debe incluir un archivo "public/WEB-INF/web.xml" con la configuracion apropiada

// ATENCION! Esta forma de pasar los props a cada página asegura poder acceder a this.props.location y this.props.history, la alternativa sería usar withRouter en cada uno de los componentes como por ejemplo en AppHeader.js

// ATENCIÓN! Para configurar el basename de la aplicación (es decir, poder desplegarla en un subdirectorio) se debe de cambiar el basename aquí del BrowserRouter, pero también añadir el parámetro homepage en el package.json

class Routing extends React.Component {
  render() {
    return (
      <BrowserRouter basename="/">
        <Switch>          
          <Route path="/" exact render={props => <Login {...props} />} />
          <Route path="/firstrun" exact render={props => <FirstRun {...props} />} />
          <Route path="/resetpassword" exact render={props => <ResetPassword {...props} />} />
          <Route path="/sensorspanel" exact render={props => <SensorsPanel {...props} />} />
          <Route path="/loaddata" exact render={props => <DataLoaderPanel {...props} />} />
          <Route path="/controlpanel" exact render={props => <ControlPanel {...props} />} />
          <Route path="/adminpanel" exact render={props => <AdminPanel {...props} />} />
          <Route path="/userprofile" exact render={props => <UserProfile {...props} />} />
          <Redirect to="/" />
        </Switch>
      </BrowserRouter>
    )
    }
}

export default Routing;